import { Col, Form, Input, InputNumber, Row, Switch, DatePicker, Select } from 'antd';
import { useEffect, useRef, useState } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import dayjs from 'dayjs';
import antMessage from '../../../utils/extend/AntdNotification';
import fetchApi from '../../../utils/api/fetchApi';
import system from "../../../config/systematic";
import getList from '../../universal/getList';

export default function MenuHolidayEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /**地区数据 */
    const [areaData, setAreaData] = useState<any>();

    const [yearData, setYearData] = useState<any>();

    /** 后端数据Service */
    let wmService = system.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }

        const fetchData = async () => {
            let yearArray = [];
            for (var i = 2026; i < 2050; i++) {
                yearArray.push({ value: i, label: i })
            }
            setYearData(yearArray);

            if (data.type === 'NEW') {
                form.setFieldValue('year', dayjs().format('YYYY'));
            }

            fetchApi.GET(wmService, {
                apiId: "area",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setAreaData(res.data);
                }
            });
        }
        fetchData();
    }, [])

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const changeDate = (e: any, key: any) => {
        if (key === 'startTime' && form.getFieldsValue()['endTime'] !== undefined) {
            if (dayjs(form.getFieldsValue()['endTime']).format("YYYY-MM-DD") < dayjs(e).format("YYYY-MM-DD")) {
                antMessage('error', '时间设置有误', '结束时间小于开始时间,请重新选择.');
                form.resetFields(['startTime']);
            }
        }

        if (key === 'endTime') {
            if (dayjs(form.getFieldsValue()['startTime']).format("YYYY-MM-DD") > dayjs(e).format("YYYY-MM-DD")) {
                antMessage('error', '时间设置有误', '开始时间大于结束时间,请重新选择.');
                form.resetFields(['endTime']);
            }
        }
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'menuHoliday',
        dateColumnName: ['startTime', 'endTime']
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '节假日'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    initialValues={{ "sortBy": 999 }}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="区域"
                                name="areaId"
                                rules={[{ required: true, message: '请选择区域!' }]}
                            >
                                <Select
                                    placeholder="区域"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(areaData, {
                                        itemName: "areaName",
                                        includeNull: false
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="年份"
                                name="year"
                                rules={[{ required: true, message: '请选择年份!' }]}
                            >
                                <Select
                                    options={yearData}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="节假日名称"
                                name="menuHolidayName"
                                rules={[{ required: true, message: '请填写节假日名称!' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="开始时间"
                                name="startTime"
                                rules={[{ required: true, message: '请选择时间' }]}
                            >
                                <DatePicker
                                    onChange={(e) => changeDate(e, 'startTime')}
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="结束时间"
                                name="endTime"
                                rules={[{ required: true, message: '请选择时间' }]}
                            >
                                <DatePicker
                                    onChange={(e) => changeDate(e, 'endTime')}
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={0}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}